import Storage from 'web-storage-cache'

//localStorage
const localStorage = new Storage()

//基础操作
export function setLocalStorage(key, value, expSecond) {
    if (expSecond && !isNaN(expSecond)) {
        return localStorage.set(key, value, { exp: expSecond });
    } else {
        return localStorage.set(key, value)
    }
}

export function getLocalStorage(key) {
    return localStorage.get(key)
}

export function removeLocalStorage(key) {
    return localStorage.delete(key)
}

export function clearLocalStorage() {
    return localStorage.clear()
}


//各需求扩展操作

/**
 * 保存登录用户信息
 * @param {Object} userInfo 用户信息
 */
export function saveLoginUser(userInfo) {
    return setLocalStorage("localuser", userInfo);
}

/**
 * 获取登录用户信息
 */
export function getLoginUser() {
    return getLocalStorage("localuser");
}

/**
 * 移除登录用户信息
 */
export function removeLoginUser() {
    return removeLocalStorage("localuser");
}

//================ 请求token处理 ================

/**
 * 保存token
 * @param {*} token 
 */
export function saveToken(token) {
    return setLocalStorage("localtoken", token);
}

/**
 * 获取token
 */
export function getToken() {
    return getLocalStorage("localtoken");
}

/**
 * 移除token
 */
export function removeToken() {
    return removeLocalStorage("localtoken");
}

//================ 购课车 ================

/**
 * 保存购买商品信息（购课车）
 * @param {Number} productId 商品ID
 * @param {Number} buyType 购买类型
 */
export function saveBuyProduct(productId, buyType) {
    return setLocalStorage("cart", { productId, buyType });
}

/**
 * 获取购买商品信息（购课车）
 */
export function getBuyProduct() {
    return getLocalStorage("cart");
}

/**
 * 移除购买商品信息（购课车）
 */
export function removeBuyProduct() {
    return removeLocalStorage("cart");
}


//================ 订单 ================
/**
 * 保存要付款的订单信息
 * @param {String} orderNo 订单号
 * @param {Number} orderMoney 订单金额
 */
export function saveOrderInfo(orderNo, orderMoney, productName) {
    return setLocalStorage("order", { orderNo, orderMoney, productName });
}

/**
 * 获取要付款的订单信息
 */
export function getOrderInfo() {
    return getLocalStorage("order");
}

/**
 * 移除要付款的订单信息
 */
export function removeOrderInfo() {
    return removeLocalStorage("order");
}

//================ 人个收款码 ================

/**
 * 保存收款码地址
 * @param {Object} qrcode 收款码
 */
export function savePayQrcode(qrcode) {
    return setLocalStorage("payqrcde", qrcode);
}

/**
 * 获取收款码地址
 */
export function getPayQrcode() {
    return getLocalStorage("payqrcde");
}

/**
 * 移除收款码地址
 */
export function removePayQrcode() {
    return removeLocalStorage("payqrcde");
}